module.exports = __webpack_public_path__ + "img/rate.20a765a6.svg";